"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmbeddedDataField = void 0;
var lodash_1 = __importDefault(require("lodash"));
var isEmbeddedDataField = function (field) {
    var type = lodash_1.default.get(field, 'meta.fullType');
    return lodash_1.default.isString(type) && lodash_1.default.split(type, '-')[0] === 'ED';
};
exports.isEmbeddedDataField = isEmbeddedDataField;
